import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';

import styles from './styles.module.scss';
import cx from "classnames";
import _ from 'lodash';
import { localizedStrings } from 'src/localization';

class SharedByView extends React.Component {
  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons; 

  }

  render() {
    const user = this.props.user;

    if (user == null) {
      return false;
    }

    const icon = _.get(user, 'icon.thumbnail');

    var name = '';
    var initials = '';

    if (user.firstName) {
      name = user.firstName;
      initials = user.firstName[0];
    }

    if (user.lastName) {
      name = `${name} ${user.lastName}`;
      initials = `${initials}${user.lastName[0]}`;
    }

    var fontColorValue = '#000';
    if (this.props.fontColor) {
      fontColorValue = `rgba(${this.props.fontColor.r}, ${this.props.fontColor.g}, ${this.props.fontColor.b}, ${this.props.fontColor.a})`;
    }

    return (
      <div className={styles.sharedBy} style={{
        color: fontColorValue,
        borderColor: fontColorValue
      }}>
        {!icon &&
          <div className={cx(styles.icon, styles.initials)}>{initials}</div>
        }

        {icon &&
          <div className={styles.icon}>
            <Image src={icon} />
          </div>
        }

        <div className={styles.details}>
          <h6 className={styles.label}> { this.localizedCommons.shared_by }: </h6>

          <h4>{name}</h4>

          <div className={styles.detailsContnet}>
            {user.title &&
              <div className={styles.title}>{user.title}</div>
            }

            <a href={`mailto:${user.email}`} className={styles.email}>
              {user.email}
            </a>

            {user.workPhone &&
              <div className={styles.phone}>
                {user.workPhone}
              </div>
            }

            {user.mobilePhone &&
              <div className={styles.phone}>
                {user.mobilePhone}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default SharedByView;